import { Paintbrush } from "lucide-react";

const ITEMS = [
  "Interior Wall Painting",
  "Ceiling Painting",
  "Door & Window Frames",
  "Skirting Boards",
  "Staining & Varnishing",
  "Free Quotes",
];

export const Marquee = ({ dark = false }) => {
  const row = (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span
            className={`font-display text-2xl sm:text-4xl font-bold tracking-tight px-6 ${
              dark ? "text-[#fbf9f5]" : "text-[#121212]"
            }`}
          >
            {item}
          </span>
          <Paintbrush className="w-5 h-5 text-[#c8102e]" strokeWidth={2.2} />
        </span>
      ))}
    </div>
  );

  return (
    <div
      data-testid="services-marquee"
      className={`overflow-hidden py-6 border-y ${
        dark ? "bg-[#121212] border-white/10" : "bg-[#f3efe6] border-black/10"
      }`}
    >
      <div className="marquee-track flex w-max">
        {row}
        {row}
      </div>
    </div>
  );
};
